import { SET_MESSAGE, CLEAR_MESSAGE } from "../constants/types";

const initialState = { message: "" };

export default function messageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MESSAGE:
            return { ...state, message: action.payload };
        case CLEAR_MESSAGE:
            return { ...state, message: "" };
        default:
            return state;
    }
}

export const clearMessage = () => ({
    type: CLEAR_MESSAGE,
});